module.exports = __webpack_public_path__ + "static/media/i4.10186e1d.svg";